module.exports = __webpack_public_path__ + "media/images/icons/israel-page-map-7621b054a6116f09629858ac0ba1cd9b.svg";